import { render, staticRenderFns } from "./CrossSell.vue?vue&type=template&id=363093f9"
import script from "./CrossSell.vue?vue&type=script&lang=js"
export * from "./CrossSell.vue?vue&type=script&lang=js"
import style0 from "./CrossSell.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports